import Box from '../components/layout/Box';

import Text from '../components/Text';
import { useState } from 'react';
import CookieSettingsModal from '../screens/Modals/CookieSettings';
import TermsModal from '../screens/Modals/Terms';
import DataPolicyModal from '../screens/Modals/DataPolicy';
import CookiePolicyModal from '../screens/Modals/CookiePolicy';
import Image from '../components/Image';

const Footer = () => {
  const [cookieSettingsModalOpen, setCookieSettingsModalOpen] = useState(false);
  const [showCookiePolicy, setShowCookiePolicy] = useState(false);
  const [showDataPolicy, setShowDataPolicy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <Box className="w-100 py-5" backgroundColor="lightBlackColor">
      <Box
        style={{ maxWidth: 940 }}
        className="container-lg justify-content-center align-items-center flex-column"
      >
        <Box className="justify-content-center">
          <Image
            style={{ width: 64, height: 'auto' }}
            source="https://kthbok-images.s3.eu-north-1.amazonaws.com/content/white-green-logo-small.png"
          />
        </Box>

        <Text
          style={{ fontWeight: '600', fontSize: 18 }}
          className="mt-2"
          color="whiteColor"
        >
          kthbok.com
        </Text>

        <Box
          className="mt-2"
          style={{
            cursor: 'pointer',
          }}
          onClick={() => {
            setCookieSettingsModalOpen(true);
          }}
        >
          <Text style={{ fontSize: 14 }} color="whiteColor">
            Inställningar för kakor (cookies)
          </Text>
        </Box>

        <Box
          className="mt-2"
          style={{
            cursor: 'pointer',
          }}
          onClick={() => {
            setShowCookiePolicy(true);
          }}
        >
          <Text style={{ fontSize: 14 }} color="whiteColor">
            Kakpolicy (cookies)
          </Text>
        </Box>

        <Box
          className="mt-2"
          style={{
            cursor: 'pointer',
          }}
          onClick={() => {
            setShowTerms(true);
          }}
        >
          <Text style={{ fontSize: 14 }} color="whiteColor">
            Användarvillkor
          </Text>
        </Box>

        <Box
          className="mt-2"
          style={{
            cursor: 'pointer',
          }}
          onClick={() => {
            setShowDataPolicy(true);
          }}
        >
          <Text style={{ fontSize: 14 }} color="whiteColor">
            Datapolicy
          </Text>
        </Box>

        <Text
          color="whiteColor"
          className="mt-5"
          style={{ fontSize: 14, textAlign: 'center' }}
        >
          Behöver du hjälp eller undrar något? Kontakta oss på
          kontakt@kthbok.com
        </Text>
      </Box>

      <CookieSettingsModal
        show={cookieSettingsModalOpen}
        setShow={setCookieSettingsModalOpen}
      />

      <CookiePolicyModal
        show={showCookiePolicy}
        setShow={setShowCookiePolicy}
      />

      <DataPolicyModal show={showDataPolicy} setShow={setShowDataPolicy} />

      <TermsModal show={showTerms} setShow={setShowTerms} />
    </Box>
  );
};

export default Footer;
